<div class="wsched-shell">

  <div class="wsched-header">
    <div class="wsched-header-text">
      <h2 class="wsched-title">Programación de horarios</h2>

      <div class="wsched-subtitle">
        <span class="wsched-person-avatar">{{ initials }}</span>

        <span class="wsched-person-name">{{ data.personName }}</span>

        <span class="wsched-status-badge" [class.wsched-status-badge--inactive]="!data.isActive">
          {{ data.isActive ? 'Activo' : 'Inactivo' }}
        </span>

        <ng-container *ngIf="data.documentLabel"> · {{ data.documentLabel }}</ng-container>
        <ng-container *ngIf="data.positionLabel"> · {{ data.positionLabel }}</ng-container>
        <ng-container *ngIf="data.employerLabel"> · {{ data.employerLabel }}</ng-container>
        <ng-container *ngIf="data.projectLabel"> — {{ data.projectLabel }}</ng-container>
      </div>
    </div>

    <div class="wsched-month-nav">
      <button type="button" class="wsched-month-btn" [disabled]="scheduleLoading" (click)="previousMonth()">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div class="wsched-month-label">{{ monthLabel }}</div>

      <button type="button" class="wsched-month-btn" [disabled]="scheduleLoading" (click)="nextMonth()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="wsched-header-actions">
      <span [matTooltip]="!canEditShiftScheduling ? 'No tienes el permiso para modificar la programación de horarios'
                        : !canEdit ? 'No cuentas con el permiso para modificar la programación' : ''"
            matTooltipPosition="above" style="display:inline-block">
        <button type="button" class="wsched-btn-clear" [disabled]="!canEdit || saving" (click)="clearMonth()">
          Limpiar mes
        </button>
      </span>

      <span [matTooltip]="!canEditShiftScheduling ? 'No tienes el permiso para modificar la programación de horarios'
                        : !canEdit ? 'No cuentas con el permiso para modificar la programación' : ''"
            matTooltipPosition="above" style="display:inline-block">
        <button type="button" class="wsched-btn-save" [disabled]="!canEdit || saving" (click)="save()">
          <mat-icon>save</mat-icon>
          Guardar programación
        </button>
      </span>

      <button type="button" class="wsched-btn-cancel" [disabled]="saving" (click)="close()">
        CANCELAR
      </button>
    </div>
  </div>

  <div class="wsched-warnings" *ngIf="warnings.length">
    <div class="wsched-warning-item" *ngFor="let warning of warnings">
      <mat-icon>warning</mat-icon>
      <span>{{ warning.Message }}</span>
    </div>
  </div>

  <!-- Patrones catorcenales (rotaciones) asignados a esta persona que tocan el mes visible -->
  <div class="wsched-rotation-bar" *ngIf="rotations.length">
    <div class="wsched-rotation-item" *ngFor="let rotation of rotations">
      <mat-icon class="wsched-rotation-item-icon">autorenew</mat-icon>
      <span class="wsched-rotation-item-text">
        Patrón <b>{{ rotation.name }}</b>
        · desde el {{ shortDateLabel(rotation.startDate) }}
        · <b>{{ rotationRangeLabel(rotation) }}</b>
        <em *ngIf="rotation.versionNumber && rotation.latestVersionNumber && rotation.versionNumber < rotation.latestVersionNumber"
            matTooltip="El patrón se modificó después de asignarse. Vuelve a asignarlo para usar la versión nueva.">
          · versión {{ rotation.versionNumber }} de {{ rotation.latestVersionNumber }}
        </em>
      </span>
      <button type="button" class="wsched-rotation-item-end" *ngIf="canEdit" [disabled]="saving" (click)="endRotation(rotation)">
        Terminar
      </button>
    </div>
  </div>

  <!-- Banner: usuario sin permiso schedule.edit-past (nadie en el sistema puede editar días pasados) -->
  <div class="wsched-warning-item wsched-warning-item--info" *ngIf="!canEditPast">
    <mat-icon>lock_clock</mat-icon>
    <span>Los días ya transcurridos no pueden programarse (<em>Programar días ya transcurridos</em> no está habilitado).</span>
  </div>

  <div class="wsched-body" *ngIf="!loading; else loadingTpl">

    <div class="wsched-sidebar">
      <div class="wsched-strip-block" *ngIf="dailyShifts.length > 0">
        <div class="wsched-strip-label wsched-strip-label--turnos">TURNOS</div>

        <div class="wsched-strip-grid">
          <div class="wsched-chip"
               *ngFor="let shift of dailyShifts"
               [ngClass]="'wsched-color--' + shift.colorKey"
               [class.wsched-chip--armed]="isPatternSelected(shift.id)"
               [class.wsched-chip--disabled]="!canEdit"
               [attr.draggable]="canEdit"
               (dragstart)="onDragStartPattern(shift.id, $event)"
               (dragend)="onDragEndPattern()"
               (click)="selectPattern(shift.id)">
            <div class="wsched-chip-name">{{ shift.name }}</div>
            <div class="wsched-chip-hours">{{ getShiftTimeRangeLabel(shift) }}</div>
          </div>
        </div>
      </div>

      <div class="wsched-strip-row" *ngIf="weeklyPatterns.length > 0">
        <div class="wsched-strip-label">PATRONES</div>

        <div class="wsched-sidebar-hint">
          Suéltalos sobre <b>la etiqueta de una semana</b> para aplicar el patrón completo, o sobre
          <b>un día</b> para asignar sólo esa jornada.
        </div>

        <div class="wsched-pattern-list">
          <div class="wsched-pattern-card"
               *ngFor="let pattern of weeklyPatterns"
               [class.wsched-pattern-card--selected]="isPatternSelected(pattern.id)"
               [class.wsched-pattern-card--disabled]="!canEdit"
               [attr.draggable]="canEdit"
               (dragstart)="onDragStartPattern(pattern.id, $event)"
               (dragend)="onDragEndPattern()"
               (click)="selectPattern(pattern.id)">
            <div class="wsched-pattern-head">
              <span class="wsched-pattern-dot" [ngClass]="'wsched-color--' + pattern.colorKey"></span>
              <span class="wsched-pattern-name">{{ pattern.name }}</span>
              <span class="wsched-pattern-hours">{{ formatHours(pattern.totalHours) }} h</span>
            </div>
            <div class="wsched-pattern-days">
              <span class="wsched-pattern-day"
                    *ngFor="let day of pattern.days"
                    [ngClass]="'wsched-color--' + day.colorKey">{{ day.letter }}</span>
            </div>
            <div class="wsched-pattern-caption">
              {{ pattern.workDaysCount }} días laborales · {{ pattern.restDaysCount }} de descanso
            </div>
          </div>
        </div>
      </div>

      <div class="wsched-strip-row" *ngIf="rotationPatterns.length > 0">
        <div class="wsched-strip-label">PATRONES CATORCENALES</div>

        <div class="wsched-sidebar-hint">
          Suéltalos sobre <b>un día</b> o sobre <b>la etiqueta de una semana</b> para iniciar el ciclo ahí;
          puedes repetirlo indefinidamente.
        </div>

        <div class="wsched-pattern-list">
          <div class="wsched-pattern-card"
               *ngFor="let rotation of rotationPatterns"
               [class.wsched-pattern-card--selected]="isPatternSelected(rotation.id)"
               [class.wsched-pattern-card--disabled]="!canEdit"
               [attr.draggable]="canEdit"
               (dragstart)="onDragStartPattern(rotation.id, $event)"
               (dragend)="onDragEndPattern()"
               (click)="selectPattern(rotation.id)">
            <div class="wsched-pattern-head">
              <span class="wsched-pattern-dot wsched-color--blue"></span>
              <span class="wsched-pattern-name">{{ rotation.name }}</span>
              <span class="wsched-pattern-hours">{{ formatHours(rotation.totalHours) }} h</span>
            </div>
            <!-- Una semana por fila (7 botones delgados): el ciclo de 14 días se ve en dos filas. -->
            <div class="wsched-pattern-days wsched-pattern-days--rotation">
              <span class="wsched-pattern-day"
                    *ngFor="let day of rotation.days"
                    [ngClass]="'wsched-color--' + day.colorKey">{{ day.letter }}</span>
            </div>
            <div class="wsched-pattern-caption">
              Ciclo de {{ rotation.cycleLengthDays }} días · {{ rotation.workDaysCount }} laborales · {{ rotation.restDaysCount }} de descanso
            </div>
          </div>
        </div>
      </div>

      <div class="wsched-pattern-empty" *ngIf="!loading && weeklyPatterns.length === 0 && dailyShifts.length === 0 && rotationPatterns.length === 0">
        Este proyecto no tiene turnos configurados todavía.
      </div>
    </div>

    <section class="wsched-main">
      <div class="wsched-toolbar">
        <span class="wsched-stat">Días programados <b>{{ scheduledDaysCount }}</b></span>
        <span class="wsched-stat">Horas del mes <b>{{ formatHours(totalMonthHours) }} h</b></span>
      </div>

      <div class="wsched-table-wrapper">
        <table class="wsched-grid" [class.wsched-grid--dragging]="isDraggingPattern">
          <thead>
            <tr>
              <th class="wsched-week-head-cell">SEMANA</th>
              <th class="wsched-head-cell"
                  *ngFor="let label of weekdayHeaders; let hi = index"
                  [class.wsched-head-cell--weekend]="hi >= 5">
                <span class="wsched-head-day">{{ label }}</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr class="wsched-grid-row" *ngFor="let week of weeks; let wi = index">
              <td class="wsched-week-cell"
                  [class.drag-over]="isWeekDragOver(wi)"
                  (dragover)="onWeekDragOver(wi, $event)"
                  (dragleave)="onWeekDragLeave(wi)"
                  (drop)="onWeekLabelDrop(wi, $event)"
                  (click)="assignToWeekLabel(wi)">
                <div class="wsched-week-cell-content">
                  <span class="wsched-week-number">Semana {{ wi + 1 }}</span>
                  <span class="wsched-week-range">{{ weekRange(week) }}</span>
                  <span class="wsched-week-hours" [class.wsched-week-hours--exceeds]="weekTotals[wi]?.exceeds">
                    {{ formatHours(weekTotals[wi]?.totalHours || 0) }} h
                    <mat-icon class="wsched-week-exceeds-icon" *ngIf="weekTotals[wi]?.exceeds" [matTooltip]="'Excede ' + maxWeeklyHours + ' h/semana'">warning</mat-icon>
                  </span>
                </div>
              </td>
              <td class="wsched-day-cell"
                  *ngFor="let cell of week; let ci = index"
                  [class.wsched-day-cell--out]="!cell.inMonth"
                  [class.wsched-day-cell--weekend]="cell.isWeekend"
                  [class.wsched-day-cell--holiday]="cell.isHoliday"
                  [class.wsched-day-cell--locked]="isCellLocked(cell)"
                  [class.wsched-day-cell--conflict]="isCellConflict(cell)"
                  [class.drag-over]="isCellDragOver(cell)"
                  (dragover)="onCellDragOver(cell, $event)"
                  (dragleave)="onCellDragLeave(cell)"
                  (drop)="onCellDrop(cell, wi, ci, $event)"
                  (click)="assignToCell(cell, wi, ci)">
                <div class="wsched-day-number-row" *ngIf="cell.dayNumber">
                  <span class="wsched-day-number">{{ cell.dayNumber }}</span>
                  <span class="wsched-day-holiday-badge" *ngIf="cell.isHoliday" matTooltip="Festivo">FESTIVO</span>
                </div>
                <mat-icon class="wsched-day-lock-icon" *ngIf="isCellLocked(cell)" matTooltip="Día no editable">lock</mat-icon>
                <mat-icon
                  class="wsched-day-conflict-icon"
                  *ngIf="isCellConflict(cell)"
                  [matTooltip]="getCellConflictReason(cell)"
                  matTooltipPosition="above"
                >
                  error
                </mat-icon>
                <div class="wsched-day-chip"
                     *ngIf="getAssignment(cell) as assigned"
                     [ngClass]="'wsched-color--' + assigned.colorKey + '-soft'">
                  <span class="wsched-day-chip-name">{{ assigned.patternName }}</span>
                  <span class="wsched-day-chip-time">{{ assigned.timeRangeLabel }}</span>
                  <mat-icon class="wsched-day-chip-rescheduled" *ngIf="assigned.isRescheduled" matTooltip="Reprogramado puntualmente">swap_horiz</mat-icon>
                  <mat-icon class="wsched-day-chip-rotation" *ngIf="isRotationDay(assigned)" [matTooltip]="rotationDayTooltip(assigned)">autorenew</mat-icon>
                  <!-- Un día que solo viene de la rotación no se quita: para cambiarlo se le asigna un turno encima. -->
                  <button type="button" class="wsched-day-chip-remove" *ngIf="canEdit && !isCellLocked(cell) && !isRotationDay(assigned)" (click)="removeAssignment(cell, wi, $event)">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <span class="wsched-day-unscheduled-tag" *ngIf="isCellUnscheduled(cell)">Sin turno</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

  </div>

  <ng-template #loadingTpl>
    <div class="wsched-loading">
      <mat-icon class="wsched-loading-icon">hourglass_empty</mat-icon>
      Cargando programación...
    </div>
  </ng-template>

</div>
